module.exports = __webpack_public_path__ + "static/media/article12.cbe6b5a1.webp";